import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useWorkshops } from '@/api/hooks/useWorkshops'
import WorkshopSettings from '@/components/organisms/workshop-settings'
import { useSetSidebarSubLabel } from '@/contexts/sidebar-sub-label-context'

export const Route = createFileRoute('/_authenticated/manage-workshops/$workshopId')({
  component: WorkshopSettingsRoute,
})

function WorkshopSettingsRoute() {
  const { workshopId } = Route.useParams()
  const navigate = useNavigate()
  const { data: workshops } = useWorkshops()
  const workshopName = workshops.find(w => w.id === workshopId)?.name

  useSetSidebarSubLabel(`/manage-workshops/${workshopId}`, workshopName)

  return <WorkshopSettings workshopId={workshopId} />
}
